import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

type Props = {
  value: string;
  editorOption?: object;
  createImage: (file: File, type: 'Poster' | 'Cover' | 'Inline') => Promise<string>;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleEditor',
  props: {
    value: null,
    editorOption: null,
    createImage: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'input', f: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: string;
  editorOption?: object;
  createImage: (file: File, type: 'Poster' | 'Cover' | 'Inline') => Promise<string>;
}


const content = ref<string>(props.value);


const onEditorChange = (_event: any) => {
  emits('input', content.value ?? '');
};

return { __sfc: true,props, content, emits, onEditorChange }
}

})